import { Fragment, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import {
  ENTITY_PROFILE_EDIT_INPUT_MIN_ROWS,
  ENTITY_PROFILE_INPUT_MAX_LENGTH,
} from '../../Entity'
import { FormFieldsContainer } from '../../Form'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
} from '../../Formik'
import { TextareaOutlineField } from '../../Textarea'
import { DOC_FLOW_FORM_FIELD_APPLY_FINAL_NAME_CHECKBOX } from '../DocFlow.constants'
import { useDocFlowContext } from '../DocFlow.hooks'
import { isDocFlowPhaseCombining } from '../DocFlow.utils.phases'
import { DocFlowVariableField } from '../DocFlowVariableField'

import * as styles from './DocFlowEditFinalDocumentFields.module.css'

function DocFlowEditFinalDocumentFields({
  profileAction,
  titleFieldName,
  ...restProps
}) {
  const { activePhase } = useDocFlowContext()

  const { t } = useTranslation()

  const inputRef = useRef(null)

  return (
    <FormFieldsContainer>
      <DocFlowVariableField
        className={styles.select}
        inputLabel={t(
          'DocumentStapling.ModalEditFinalDocumentVariableLabelKey'
        )}
        inputRef={inputRef}
        titleFieldName={titleFieldName}
      />
      <FormikField
        {...restProps}
        autoFocus
        clearable
        required
        withoutManualResize
        Component={TextareaOutlineField}
        elementRef={inputRef}
        fieldComponentProps={{ className: styles.field }}
        getErrorProps={getFormikFormFieldErrorProps}
        label={t('DocumentStapling.ModalEditFinalDocumentTitleLabelKey')}
        maxLength={ENTITY_PROFILE_INPUT_MAX_LENGTH}
        minRows={ENTITY_PROFILE_EDIT_INPUT_MIN_ROWS}
        name={titleFieldName}
        placeholder={t(
          'DocumentStapling.ModalEditFinalDocumentTitlePlaceholderKey'
        )}
      />
      {isDocFlowPhaseCombining(activePhase) && profileAction ? (
        <FormikField
          Component={Checkbox}
          Field={Fragment}
          className={styles.checkbox}
          getValueProps={getFormikCheckboxFieldValueProps}
          iconClassName={styles.checkboxIcon}
          label={t(
            'DocumentStapling.ApplyToAllDocumentsFinalNameCheckboxTitleKey'
          )}
          name={DOC_FLOW_FORM_FIELD_APPLY_FINAL_NAME_CHECKBOX}
          size={CHECKBOX_SIZE.small}
        />
      ) : null}
    </FormFieldsContainer>
  )
}

export default DocFlowEditFinalDocumentFields
